var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        fill: "#000000",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("title", [_vm._v("phone_rotation [#F09A0FFF]")]),
        _vm._v(" "),
        _c("desc", [_vm._v("Created with Sketch.")]),
        _vm._v(" "),
        _c("defs"),
        _vm._v(" "),
        _c(
          "g",
          {
            attrs: {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: "none",
              "fill-rule": "evenodd",
            },
          },
          [
            _c(
              "g",
              {
                attrs: {
                  id: "Dribbble-Light-Preview",
                  transform: "translate(-140.000000, -7279.000000)",
                  fill: "#F09A0FFF",
                },
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      id: "icons",
                      transform: "translate(56.000000, 160.000000)",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M103.718658,7130.3969 L103.678821,7130.3559 C103.301899,7129.9719 102.682888,7129.9479 102.276343,7130.3009 L101.365191,7131.0949 L101.365191,7120.9999 C101.365191,7119.8949 100.449954,7118.9999 99.3222511,7118.9999 L86.0431402,7118.9999 C84.9144157,7118.9999 84.0002,7119.8949 84.0002,7120.9999 L84.0002,7122.0099 C84.0002,7122.5569 84.4527112,7122.9999 85.0114554,7122.9999 L85.0318848,7122.9999 C85.5906289,7122.9999 86.0431402,7122.5569 86.0431402,7122.0099 L86.0431402,7121.9899 C86.0431402,7121.4429 86.4956514,7120.9999 87.0543955,7120.9999 L98.3109958,7120.9999 C98.8697399,7120.9999 99.3222511,7121.4429 99.3222511,7121.9899 L99.3222511,7131.0949 L98.4989463,7130.3429 C98.0903582,7129.9699 97.4498965,7129.9919 97.0688882,7130.3919 L97.0658237,7130.3959 C96.6837939,7130.7959 96.7072877,7131.4239 97.1168973,7131.7959 L99.0168316,7133.5249 C99.8023421,7134.2389 101.017891,7134.2369 101.801359,7133.5209 L103.678821,7131.8059 C104.091495,7131.4289 104.10886,7130.7949 103.718658,7130.3969 L103.718658,7130.3969 Z M92.1719606,7126.9899 C92.1719606,7126.4429 91.7194494,7125.9999 91.1607052,7125.9999 L87.0543955,7125.9999 C86.4956514,7125.9999 86.0431402,7126.4429 86.0431402,7126.9899 L86.0431402,7136.0099 C86.0431402,7136.5569 86.4956514,7136.9999 87.0543955,7136.9999 L91.1607052,7136.9999 C91.7194494,7136.9999 92.1719606,7136.5569 92.1719606,7136.0099 L92.1719606,7126.9899 Z M94.2149008,7125.9999 L94.2149008,7136.9999 C94.2149008,7138.1049 93.2996636,7138.9999 92.1719606,7138.9999 L86.0431402,7138.9999 C84.9144157,7138.9999 84.0002,7138.1049 84.0002,7136.9999 L84.0002,7125.9999 C84.0002,7124.8949 84.9144157,7123.9999 86.0431402,7123.9999 L92.1719606,7123.9999 C93.2996636,7123.9999 94.2149008,7124.8949 94.2149008,7125.9999 L94.2149008,7125.9999 Z M90.1290205,7133.9899 L90.1290205,7134.0099 C90.1290205,7134.5569 89.6765092,7134.9999 89.1177651,7134.9999 L89.0973357,7134.9999 C88.5385915,7134.9999 88.0860803,7134.5569 88.0860803,7134.0099 L88.0860803,7133.9899 C88.0860803,7133.4429 88.5385915,7132.9999 89.0973357,7132.9999 L89.1177651,7132.9999 C89.6765092,7132.9999 90.1290205,7133.4429 90.1290205,7133.9899 L90.1290205,7133.9899 Z",
                        id: "phone_rotation-[#F09A0FFF]",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }